import React from 'react'

import { getPublicationInfoFromRouteResolution } from 'component-library/templates/Publication/SharedPublication.routing'
import { createRegisterableComponent } from 'common/routing/page-definition'

import { ArticleHero } from './ArticleHero'
import { getVideoQueue } from 'component-library/templates/Publication/lib/get-video-queue'
import { FigcaptionRenderOptions } from '../ArticleImage/ArticleImage'

export interface InternalProps {
    adUnitPath: string
    heading: string
    publicationPathname?: string
    figcaptionRenderOptions?: FigcaptionRenderOptions
    imageRenderType?: 'feature'
}
export const ArticleHeroRegistration = createRegisterableComponent(
    'article-hero',
    (props: InternalProps, services) => {
        const publicationInfo = getPublicationInfoFromRouteResolution(services)
        if (publicationInfo.publication.kind !== 'article') {
            throw new Error('Article component rendered for non-article')
        }

        return (
            <ArticleHero
                heroImage={publicationInfo.publication.heroImage}
                heroVideo={publicationInfo.publication.heroVideo}
                heading={publicationInfo.publication.heading}
                isVideoStickyEnabled={false}
                showVideoTitles={true}
                publicationPathname={publicationInfo.publication.slug}
                onEvent={services.onEvent}
                getVideoQueue={() => getVideoQueue(services, publicationInfo.publication.id)}
                figcaptionRenderOptions={props.figcaptionRenderOptions}
                imageRenderType={props.imageRenderType}
                adUnitPath={props.adUnitPath}
            />
        )
    }
)
